import { combineEpics } from 'redux-observable';
import { getOwnerDealsEpic } from './get-owner-deals';
import { getArtistDealsEpic } from './get-artist-deals';
import { getDealsWhenActiveEpic } from './get-deals-when-active';

const dealsEpic = combineEpics(
  getOwnerDealsEpic,
  getArtistDealsEpic,
  getDealsWhenActiveEpic
);

export default dealsEpic;
